import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_tech-premium/artifacts/r7pl1vnl_WEGTECH_logo_transparent.png" 
              alt="WEGTECH" 
              className="footer-logo"
            />
            <p className="footer-description">
              Tecnologia segura para empresas modernas. Especialistas em cibersegurança e soluções enterprise.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Navegação</h3>
            <nav className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/sobre" className="footer-link">Sobre</Link>
              <Link to="/servicos" className="footer-link">Serviços</Link>
              <Link to="/parceiros" className="footer-link">Parceiros & Integradores</Link>
              <Link to="/contato" className="footer-link">Contato</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">Contato</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone size={18} />
                <a href={companyInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <a href={`mailto:${companyInfo.email}`}>
                  {companyInfo.email}
                </a>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} WEGTECH. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;